import { useTranslations } from 'next-intl';

import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { IconButton } from '@flipster/react/design-system/icon-button';
import Formatted from '@flipster/react/design-utils/formatted';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { hstack } from '@flipster/styled-system/patterns';
import { TableCell } from '@flipster/ui/Table';

interface Props {
  price: string | null;
  precision: number;
  /** TP 컬럼에서만 안내(info) 버튼을 노출 */
  showInfo: boolean;
}

/**
 * airdrop 포지션의 TP/SL 표시 셀. useTranslations(intl context) 구독을 여기로 격리해,
 * 일반(비-airdrop) TpSlCol이 intl context 변경에 리렌더되지 않도록 한다.
 */
export const AirdropTpSlCell = ({ price, precision, showInfo }: Props) => {
  const transCommon = useTranslations('Common.r250401');
  const transAssets = useTranslations('Assets.r250401');

  return (
    <TableCell>
      <div className={hstack()}>
        <Formatted.Number
          value={price}
          precision={precision}
          toFixed
          zeroString='-'
          css={{ textStyle: 'Text/S/Monospace/Regular', color: 'content.default.level-5' }}
        />
        {showInfo && (
          <IconButton
            hierarchy='quaternary'
            size='small'
            icon={<InformationCircleIcon />}
            onClick={() =>
              dialog.open({
                title: {
                  label: transAssets('Profit_limit'),
                },
                content: transAssets('Profit_limit_bottomsheet_description'),
                buttons: {
                  primary: <Dialog.Button hierarchy='primary' label={transCommon('Ok')} />,
                },
              })
            }
          />
        )}
      </div>
    </TableCell>
  );
};
